export default __webpack_public_path__ + "static/lsa-devices-mobile-7f0921661eefda4243160b80cf900c43.jpg";